"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useNonce;

var _useWebChatUIContext2 = _interopRequireDefault(require("./useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useNonce() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      nonce = _useWebChatUIContext.nonce;

  return [nonce];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VOb25jZS5qcyJdLCJuYW1lcyI6WyJ1c2VOb25jZSIsIm5vbmNlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxRQUFULEdBQW9CO0FBQ2pDLDZCQUFrQixvQ0FBbEI7QUFBQSxNQUFRQyxLQUFSLHdCQUFRQSxLQUFSOztBQUVBLFNBQU8sQ0FBQ0EsS0FBRCxDQUFQO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0VUlDb250ZXh0IGZyb20gJy4vdXNlV2ViQ2hhdFVJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZU5vbmNlKCkge1xuICBjb25zdCB7IG5vbmNlIH0gPSB1c2VXZWJDaGF0VUlDb250ZXh0KCk7XG5cbiAgcmV0dXJuIFtub25jZV07XG59XG4iXX0=